/**
 * Languages
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    localeCodes: {
        // from https://appmakers.dev/bcp-47-language-codes-list/
        ar: "ar-SA",
        cs: "cs-CZ",
        da: "da-DK",
        de: "de-DE",
        el: "el-GR",
        en: "un-US",
        es: "es-MX",
        fi: "fi-FI",
        fr: "fr-CA",
        he: "he-IL",
        hi: "hi-IN",
        hu: "hu-HU",
        id: "id-ID",
        it: "it-IT",
        ja: "ja-JP",
        ko: "ko-KR",
        nl: "nl-NL",
        no: "no-NO",
        pl: "pl-PL",
        pt: "pt-BR",
        ro: "ro-RO",
        ru: "ru-RU",
        sk: "sk-SK",
        sv: "sv-SE",
        th: "th-TH",
        tr: "tr-TR",
        zh: "zh-CN",
    },
    all_languages: null,
    active_languages: null,
};

// getters
const getters = {
    languages_type_loader: (state) => (id) => {
        alert(id);
        return state.languages_type_loader;
    },
    all_languages: (state) => {
        return state.all_languages;
    },
    localeCodes: (state) => {
        return state.localeCodes;
    },
};

// actions
const actions = {
    async fetchLanguages({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitLanguages", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateLanguages", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitLanguages(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateLanguages(state, payload) {
        if (payload.method == "post" && payload.with) {
            if (state[payload.property] == null) state[payload.property] = [];
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id), 1);
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
